import React from 'react';
import { Route, Switch } from 'react-router-dom';

import DocsCard from './DocsCard';
import DocsPage from './DocsPage';

import classes from './DevPortal.module.css';

const DevPortal = () => (
    <div className={classes.DevPortal}>
        <Switch>
            <Route
                component={DocsPage}
                path="/devportal/docs"
            />
            <Route
                component={DocsCard}
                path="/devportal"
            />
        </Switch>
    </div>
);

export default DevPortal;
